import React, { useState, useEffect } from 'react';
import cake from '../images/cake.png';
import voucherImg from '../images/voucherImg.png';
import faqDivider from '../images/faqDivider.png';
import satsImgOne from '../images/satsImgOne.png';
import satsImg from '../images/sats.png';
import { useNavigate } from 'react-router-dom';
import crdSpndIcon from '../images/cardSpendIcon.png';
// import spotlightIconOne from '../images/spotlightOne.png';
import spotlightIconTwo from '../images/spotlightTwo.png';
// import spotlightIconThree from '../images/spotlightThree.png';
import spotlightElite from '../images/spotlightElite.png';
import line from '../images/line.png';
import * as APIHelper from '../Helper/apiFetch';
import FAQ from './FAQ';
import Marquee from "react-fast-marquee";
import TermsAndCondition from "../components/TermsAndCondition";
import * as nativeEvents from '../Helper/native';
import { BsShareFill } from "react-icons/bs";
import { HiOutlineArrowLeft } from "react-icons/hi2";

/* const spotlightIcons = {
    ELITE: [],
    INTRO: [spotlightIconOne],
    VCO: [spotlightIconThree],
    NOCARD: [spotlightIconTwo],
}; */

const initiaData = require('../components/urlEncodeTest.json');
const IplHeader = () => {
    const targetDate = new Date('2025-06-03T23:59:59');
    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());
    const [showTimer, setShowTimer] = useState(false);
    const [shimmeLoader, setShimmer] = useState(false);
    const [leaderBoardData, setLeaderBoardData] = useState();
    const [voucherPer, setVoucherPer] = useState(0);
    const [per, setPer] = useState(0);
    const [totalTxnAmt, setTotalTxnAmt] = useState(0);
    const [cardType, setCardType] = useState('ELITE');
    const [earnedSats, setEarnedSats] = useState(0);
    const [cardPaymentStatus, setCardPaymentStatus] = useState(true);
    // const [top5Data, setTop5Data] = useState();
    const [position, setPosition] = useState(initiaData?.topStacker.positionData);

   
    const navigate = useNavigate();

    useEffect(() => {
        // Update remaining time every second
        const timer = setInterval(() => {
            const updatedRemainingTime = calculateRemainingTime();
            setRemainingTime(updatedRemainingTime);
            if (updatedRemainingTime.days <= 2 && !showTimer) {
                setShowTimer(true);
            }
        }, 1000);
        const fetchCampaignData = async () => {
            setShimmer(true);
            try {
                const resData = await APIHelper.topFive();
                setShimmer(false);
                const totalTxnAmount = resData?.totalTxnAmt ? resData?.totalTxnAmt : 0;
                const totalVoucherTxnAmount = resData?.totalVoucherTxnAmt ? resData?.totalVoucherTxnAmt : 0
                setPer(Math.min((totalTxnAmount / 3500) * 100, 100));
                setLeaderBoardData(resData.topFive);
                setCardType(resData?.cardIssued ? resData?.cardIssued.toUpperCase() : 'ELITE')
                setCardPaymentStatus(resData?.cardPayment)
                setVoucherPer(Math.min((totalVoucherTxnAmount / 1000) * 100, 100));
                setPosition({ sats: resData.user });
                setTotalTxnAmt(resData?.totalTxnAmt);
                setEarnedSats(resData?.earnedSats);
                if (resData.error) {
                    navigate('/error');
                    return;
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
        fetchCampaignData();
        // Clear the interval when the component unmounts
        return () => clearInterval(timer);
    }, []);

    function calculateRemainingTime() {
        const now = new Date();
        const difference = targetDate - now;
        // Check if the target time has already passed
        if (difference < 0) {
            return 0;
        }
        // Convert the difference to hours, minutes, and seconds
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return { hours, minutes, seconds, days };
    }

    // const currentIcons = spotlightIcons[cardType] || [];

    const shareWithFriends = () => {
        // APIHelper.postAnalytics("share_from_home");
        nativeEvents.shareWithFriends(initiaData.floatingShareMsg.msg);
    }

    const goBack = () => {
        // APIHelper.postAnalytics("share_from_home");
        nativeEvents.goBack();
    }

    const trimUserName = (user) => {
        user = user.toLowerCase().trim();
        if (user.length > 0) {
            user = user.charAt(0).toUpperCase() + user.slice(1);
            const spaceIndex = user.indexOf(" ");
            if (spaceIndex > -1 && user.length > spaceIndex + 1) {
                const secondPartLength = "";
                user = user.substring(0, spaceIndex + 1) + "*".repeat(secondPartLength);
            }
        }
        if (user.length > 20) {
            return user.slice(0, 20) + "...";
        } else {
            return user;
        }
    };

    const TopFive = (props) => {
        var { user, totalInr } = props?.userData;
        user = trimUserName(user);
        return (
            <div className=" d-flex justify-content-between top-stackers">
                <div>
                    <span style={{ color: '#000000', fontWeight: 500 }}>{props.rank}.</span>
                    <span className="userName" style={{ color: '#000000', fontWeight: 500 }}>{user}</span>
                </div>
                <div>
                    {/* <img className="sastImg mb-1" src={satsImgOne} alt={"icon"} /> */}
                    <span className="userSats" >₹{Math.round(totalInr)}</span>
                    {/* <span className="userSats">*****</span> */}
                </div>
            </div>
        );
    };

    return (
        <div style={{ overflow: 'hidden' }}>
            <div className='headder'>
                <div className='headderMarquee'>
                    <div className='rightLayout'>
                    </div>
                    <div className='leftLayout'>
                    </div>
                    <Marquee speed={30} gradientColor='none' direction='left'>
                        <div className='wazirxHeadderTimerTitle'>
                            Bitcoin Premier League is ending soon! &nbsp;&nbsp;
                        </div>
                    </Marquee>
                    <div className='campTimerContainer' style={{ width: "130px", marginLeft: '0px' }}>
                        <img alt=' ' className='timerIcon' src={'https://assets.gosats.io/notification/2024/12/1734692217708'} />
                        <div className='timeCounter'>
                            {remainingTime === 0 ? (
                                '00:00:00'
                            ) : (
                                <div style={{ display: 'flex', gap: '2px', marginBottom: '2px' }}>
                                    {remainingTime?.days > 2 ? `${remainingTime?.days} days left` : `${String(remainingTime.days * 24 + remainingTime.hours).padStart(2, '0')}:${String(remainingTime.minutes).padStart(2, '0')}:${String(remainingTime.seconds).padStart(2, '0')}`}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* <div className='headderDiv'></div */}
                <div className='headerBgColor'>
                <div className='headerImgContainerOne'>
                    <div className='headerCtaContainer'>

                    </div>
                    <div className='headerCta'>
                        {/* <button className="shareCta" onClick={() => goBack()}>
                        <HiOutlineArrowLeft size={24} color='#5C005D' />
                    </button> */}
                        <button className="shareCta" onClick={() => shareWithFriends(initiaData.floatingShareMsg.msg)}>
                            <BsShareFill size={22} color='#FFFFFF' />
                        </button>
                    </div>

                    <div className='head-title'>BITCOIN PREMIER LEAGUE</div>
                    <div className='head-subtitle'>Predict match winners, test your cricket knowledge & keep the streak going to unlock big rewards this IPL season!</div>
                    <div className='' style={{marginTop: '-40px'}}>
                        <img src={cake} style={{ width: '236px', height: 'auto' }} />
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}
export default IplHeader;